import React, { useEffect, useRef } from "react";
import "./all-rankings.m.css";
import { Button, SvgIconHandler } from "../../atoms";
import { Calendar } from "./calendar";

export const YearDropdown = ({
  isDesktop,
  yearDropdownActive,
  setYearDropdownActive,
  yearData,
  rankingEntitySlug,
  entitiesByYearJson,
  page,
  activeYear,
  onYearChange,
}) => {
  const dropdownRef = useRef(null);
  const toggleScroll = () => {
    setYearDropdownActive(true);
    document.body.classList.add("no-scroll");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (yearDropdownActive && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setYearDropdownActive(false);
        document.body.classList.remove("no-scroll");
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [yearDropdownActive]);
  return (
    <>
      {!isDesktop && (
        <div
          styleName={`overlay ${yearDropdownActive ? "overlay-active" : "overlay-inactive"}`}
          onClick={() => setYearDropdownActive(false)}
        ></div>
      )}
      <div ref={dropdownRef} styleName={`dropdown ${yearDropdownActive ? "dropdown-active" : "dropdown-inactive"}`}>
        <div styleName="dropdown-heading">Select Year</div>
        <div
          styleName={`dropdown-close ${page === "b-schools" ? "b-close" : ""}`}
          onClick={() => setYearDropdownActive(false)}
        >
          <SvgIconHandler type="close" height="12" width="12" viewBox="0 0 12 12" />
        </div>
        <div>
          {page !== "b-schools" && page !== "top-billionaires"
            ? yearData.map((yearObj) => {
                const matchingYear = entitiesByYearJson.find((item) => item.id === yearObj?.id);
                if (!matchingYear) return null;

                return (
                  <a
                    href={`/rankings/${rankingEntitySlug}/${matchingYear?.slug}`}
                    styleName={`dropdown-items ${yearObj.name === activeYear ? "dropdown-items-active" : ""}`}
                    onMouseDown={() => onYearChange && onYearChange(yearObj.name)}
                  >
                    {yearObj?.name}
                  </a>
                );
              })
            : yearData.map((year) => {
                return (
                  <a
                    href={`/rankings/${rankingEntitySlug}/${year}`}
                    styleName={`dropdown-items ${year === parseInt(activeYear) ? "dropdown-items-active" : ""}`}
                    onMouseDown={() => onYearChange && onYearChange(year.toString())}
                  >
                    {year}
                  </a>
                );
              })}
        </div>
      </div>
      <Button onClickFunction={toggleScroll}>
        <>
          {!isDesktop ? <Calendar /> : "Year: "}
          <span styleName="active-year">&nbsp;{activeYear}</span>
        </>
        <SvgIconHandler type={"arrow"} width={24} height={24} viewBox="0 0 24 24" />
      </Button>
    </>
  );
};
